module.exports = "/_next/static/images/harajuku_pizza_takeout-1e62259689cc79b1f394fc0fdaf3fadb.jpg";